module.exports = __webpack_public_path__ + "img/logo événement active.25910d2e.png";